import React, { useState } from 'react';
import { Spacing } from 'works/legacy/lib/style-helper';
import { Input, InputNumber, Space, Button, Row } from 'antd';

type ValuePair = [number, number];

export const NumberRangeFilter = ({
  onChange,
  onSearch,
  defaultValue,
  min = 1,
  max = 999,
  enforceOrder,
}: {
  onSearch: (values: ValuePair) => void;
  onChange?: (values: ValuePair) => void;
  defaultValue?: number[];
  min?: number;
  max?: number;
  enforceOrder?: boolean;
}) => {
  const [minInput, setMinInput] = useState(defaultValue?.[0]);
  const [maxInput, setMaxInput] = useState(defaultValue?.[1]);

  const validateMinInput = () => {
    if (enforceOrder && minInput && maxInput && minInput > maxInput) {
      setMinInput(maxInput);
      triggerOnChange([maxInput, maxInput]);
    }
  };

  const validateMaxInput = () => {
    if (enforceOrder && minInput && maxInput && maxInput < minInput) {
      setMaxInput(minInput);
      triggerOnChange([minInput, minInput]);
    }
  };

  const triggerOnChange = (value: ValuePair) => onChange?.(value);

  return (
    <>
      <Space style={{ display: 'flex', marginBottom: Spacing.baseSpacing / 2 }}>
        <Input.Group compact style={{ display: 'flex' }}>
          <InputNumber
            min={min}
            max={max}
            autoFocus={true}
            style={{ width: 70, textAlign: 'center' }}
            placeholder="Min"
            value={minInput}
            onChange={(value) => {
              setMinInput(value as number);
              triggerOnChange([value as number, maxInput!]);
            }}
            onBlur={validateMinInput}
          />
          <Input
            className="site-input-split"
            style={{
              width: 30,
              borderRight: 0,
              pointerEvents: 'none',
            }}
            placeholder="~"
            disabled
          />
          <InputNumber
            min={min}
            max={max}
            className="site-input-right"
            style={{ width: 70, textAlign: 'center' }}
            placeholder="Max"
            value={maxInput}
            onChange={(value) => {
              setMaxInput(value as number);
              triggerOnChange([minInput!, value as number]);
            }}
            onBlur={validateMaxInput}
          />
        </Input.Group>
      </Space>
      <Row justify="end">
        <Button
          type="primary"
          onClick={() => {
            if (!minInput || !maxInput) {
              return;
            }

            onSearch?.([minInput, maxInput]);
          }}
          size="small"
          style={{ width: '80px' }}
        >
          Apply
        </Button>
      </Row>
    </>
  );
};
